import React, { useCallback, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import RightSidebarChat from "./RightSidebarChat";
import LeftSideBarChat from "./LeftSideBarChat";
import sidebarstyle from '../../../css/connect.module.css'
import { SENDER } from "../../shared/Constant";
import axiosInstance from "../../../utils/axiosInstance";
import { chatGetAllocatedUsers, chatGetUsers, fetchChatUsers, getliveSupportByExternal, sendMsg, updateChatUsersCount, updatelivesupportflag, updaterequestUnallocate } from "../../shared/ApiEndpoint";
import login from '../../../css/login.module.css';
import { CurrentUserId, CurrentUserName } from "../../shared/shared";
import CenterSideBarChat from "./CenterSideBarChat";
import { useSocket } from "../../Socket/SocketIo";
// import UsechatSockets from "../../Socket/UseChatSocket";




export default function ChatApp() {
  const { allMessages } = useSocket();
  const [channelsData,setChannelData]= useState([])
  const [unAllocatedChannelData,setUnallocatedChannelData]=useState([])
  const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedChannelId, setSelectedChannelId] = useState(null);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState({});
  const [selectedDetails,setSelectedDetails] = useState({
    channel_id: null,
    groupName: null,
    username: null,
    external_id:null
  });
   const [selectedDetailsLeftChat,setSelectedDetailsLeftChat] = useState({
    channel_id: null,
    groupName: null,
    username: null,
    userId:null
  });
  const [livesupportDatas,setIsLiveSupportDatas]=useState({
    live_support_handoff:false,
    support_session:""
  })

  const [openChannels, setOpenChannels] = useState({});
  const [openUnallocatedChannels, setOpenUnallocatedChannels] = useState({});
  // const timerRef = useRef(null);
  useEffect(() => {
     fetchChat_users();
    fetchUnallocatedChat_users();
    document.body.style.overflow = "hidden";
   
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

useEffect(() => {
  if (channelsData?.length) {
    const openMap = {};
    channelsData.forEach(channel => {
      if (channel?.groups?.[0]?.users) {
        openMap[channel.name] = true;
      }
    });
    setOpenUnallocatedChannels(openMap);
  }

  if (unAllocatedChannelData?.length) {
    const openMap = {};
    unAllocatedChannelData.forEach(channel => {
      if (channel?.groups?.[0]?.users) {
        openMap[channel.name] = true;
      }
    });
    setOpenChannels(openMap);
  }
}, [channelsData, unAllocatedChannelData]);

useEffect(() => {
  if (!allMessages || allMessages.length === 0) return;

  const latest = allMessages[allMessages.length - 1];

  if (latest.event === "channel_message") {
    const { channel_id, message } = latest.data;

    // Match with your selected details
    if (
      selectedUserId &&
      selectedDetails?.channel_id === channel_id &&
      selectedDetails?.groupName
    ) {
      fetchUsersChat(selectedUserId, channel_id, selectedDetails.groupName);
    }

    // Based on message type
    if (message?.type === "message") {
      fetchChat_users();
    } else if (message?.type === "request") {
      fetchUnallocatedChat_users();
    }
  }
}, [allMessages]);


const handleSocketMessage = useCallback((data) => {
    const {type } = data;

    if (
      selectedUserId &&
      selectedDetails?.channel_id &&
      selectedDetails?.groupName
    ) {
      fetchUsersChat(selectedUserId, selectedDetails.channel_id, selectedDetails.groupName);
    }

    if (type === "message") {
      fetchChat_users();
    } else if (type === "request") {
      fetchUnallocatedChat_users();
    }
  }, [selectedUserId, selectedDetails]);

  // UsechatSockets(handleSocketMessage);

  const fetchChat_users = async()=>{
    try {
      const userId = CurrentUserId;
      const resp = await axiosInstance.get(`${chatGetUsers}/${userId}`, { withCredentials: true });

    if(resp?.status === 200){
    const data= resp?.data?.map(channel => ({
    name: channel.channel_name,
    channel_id: channel.channel_id,
    groups: channel.intents.map(intent => ({
      name: intent.intent,
      users: intent.usernames.map(user => ({
        id: user.id,
        name: user.name,
        unread_count: user.unread_count,
        external_id:user.external_id||"",
        profileUrl: "" // or add logic to fill this if needed
      }))
    }))
  }));
      setChannelData(data)
    }
    } catch (error) {
      console.error(error);
    }
  }

    const fetchUnallocatedChat_users = async()=>{
    try {
      const userId = CurrentUserId;
      const resp = await axiosInstance.get(`${chatGetAllocatedUsers}/${userId}`, { withCredentials: true });

    if(resp?.status === 200){
    const data= resp?.data?.map(channel => ({
    name: channel.channel_name,
    channel_id: channel.channel_id,
    groups: channel.intents.map(intent => ({
      name: intent.intent,
      users: intent.usernames.map(user => ({
        id: user.id,
        name: user.name,
        unread_count: user.unread_count,
        external_id:user.external_id,
        profileUrl: "" // or add logic to fill this if needed
      }))
    }))
  }));
      setUnallocatedChannelData(data)
    }
    } catch (error) {
      console.error(error);
    }
  }
  const updateUnreadCount = async (session_id,channel_id) => {
    const res = await axiosInstance.put(updateChatUsersCount, {
     ...(session_id && { session_id }),
     ...(channel_id && { channel_id }),
     ...(CurrentUserId && {user_id:CurrentUserId})
    }, { withCredentials: true });
    if(res.status===200){
      setChannelData((prevData) =>
        prevData.map((channel) => {
          if (channel.channel_id !== channel_id) return channel;

          return {
            ...channel,
            groups: channel.groups.map((group) => ({
              ...group,
              users: group.users.map((user) =>
                user.id === session_id ? { ...user, unread_count: 0 } : user
              ),
            })),
          };
        })
      );
    }
  }
const fetchUsersChat = async (userId, channel_id, groupName) => {
  const resp = await axiosInstance.post(fetchChatUsers, {
    ...(userId && { session_id: userId }),
    ...(channel_id && { channel_id }),
    ...(groupName && { intent: groupName }),
    ...(CurrentUserId &&{user_id:CurrentUserId})
  }, { withCredentials: true });

  if (resp?.status === 200) {
    console.log("Response from API:", resp.data);

    const data = resp?.data[userId]?.map(message => ({
      text: message.text,
      sender: message.sender,
      time: message.time
    })) || [];

    setMessages((prev) => ({
      ...prev,
      [userId]: data
    }));
  }
};

const fetch_is_liveusersupport=async(session_id)=>{
  try{
    const payload = {
      session_id:session_id
    }
    const res= await axiosInstance.post(getliveSupportByExternal,payload,{
      withCredentials:true
    })
    if(res.status===200){
      console.log(res?.data)
      setIsLiveSupportDatas({
        live_support_handoff:res?.data?.live_support_handoff,
        support_session:res?.data?.session_id
      })
    }
  }catch(error){
    console.error(error)
  }
}

const handleunallocateUpdate =async(session_id,channel_id,intent,external_id)=>{
  try {
   const payload = {
  ...(session_id && { session_id }),
  ...(channel_id && { channel_id }),
  ...(intent && { intent }),
  ...(CurrentUserId && { userid: CurrentUserId })
};
console.log(payload,"from func")

    const resp=await axiosInstance.post(updaterequestUnallocate,payload,{
      withCredentials: true
    })
    if(resp.status===200){
      console.log("updated")
        fetchUnallocatedChat_users();
          fetchChat_users();
          fetchUsersChat(session_id,channel_id,intent)
          setSelectedUserId(session_id)
          setSelectedDetails({
            channel_id:channel_id,
            groupName:intent,
            external_id:external_id
          })

    }
  } catch (error) {
    console.log(error)
  }
}

  const handleUserClickLeft = (userId, channel_id, groupName,username,external_id) => {
   
    setSelectedDetailsLeftChat({
      channel_id: channel_id,
      groupName: groupName,
      username: username,
      userId:userId
    })
  handleunallocateUpdate(userId,channel_id,groupName,external_id);
  fetch_is_liveusersupport(userId);
  };

  const handleUserClick = (userId, channel_id, groupName,username,external_id) => {
    setSelectedUserId(userId);
      setSelectedChannelId(channel_id)
    setSelectedDetails({
      channel_id: channel_id,
      groupName: groupName,
      username: username,
      external_id:external_id
    })
    // setOpenChannels((prev) => ({ ...prev, [channelName]: true }));
   fetchUsersChat(userId, channel_id, groupName);
   updateUnreadCount(userId,channel_id);
   fetch_is_liveusersupport(userId);
   console.log(external_id,"external_id")
  };
  
  const updateLiveSupport=async(session_id)=>{
    try {
      const payload = {
      session_id:session_id
    }
      const res= await axiosInstance.post(updatelivesupportflag,payload,{
        withCredentials:true
      })
      if (res.status===200){
         setIsLiveSupportDatas(prev => ({
        ...prev,
        live_support_handoff: false
      }));
      }
    } catch (error) {
      console.error(error)
    }
  }


  const toggleChannel = (name) => {
    setOpenChannels((prev) => ({ ...prev, [name]: !prev[name] }));
  };
    const toggleUnallocatedChannel = (name) => {
    setOpenUnallocatedChannels((prev) => ({ ...prev, [name]: !prev[name] }));
  };


  const handlePostMessage=async(channel_id,intent,session_id,message,external_id) => {
    const payload={
      ...(channel_id && { channel_id }),
      ...(intent && { intent }),
      ...(session_id && { session_id }),
      ...(CurrentUserName && {username:CurrentUserName }),
      ...(message && { message }),
      ...(CurrentUserId && {sender_id:CurrentUserId }),
      ...(external_id && {external_id:external_id }),
          sender: "me"
    }

    const resp = await axiosInstance.post(sendMsg,payload, { withCredentials: true });

    if(resp?.status===200){
      // fetchChat_users();
      console.log("msg sent")
    }
  }


  const handleSend = () => {
    if (!input.trim()) return;
    const newMessage = {
      text: input,
      sender: "me",
      time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    };
     setMessages((prev) => {
    const updated = {
      ...prev,
      [selectedUserId]: [...(prev[selectedUserId] || []), newMessage],
    };

    const sender=updated[selectedUserId]?.[updated[selectedUserId].length-1]?.sender;
    // Scroll happens after message state is updated
    setTimeout(() => {
      const container = document.querySelector(`.${sidebarstyle.messagescontainer}`);
         if (container && sender === SENDER) {
           const isOverflowing = container.scrollHeight > container.clientHeight;
           if (isOverflowing) {
             container.scrollTop = container.scrollHeight;
           }
         }

    }, 0);

    return updated;
  });
  handlePostMessage(selectedDetails.channel_id,selectedDetails.groupName,selectedUserId,input,selectedDetails.external_id)
    setInput("");
  };

  const selectedMessages = messages[selectedUserId] || [];
  const selectedUser = channelsData
    .flatMap((channel) => channel.groups.flatMap((group) => group.users))
    .find((user) => user.id === selectedUserId);

    console.log(selectedUserId,"selectedUserId")
  return (
    <div className="container-fluid p-0" style={{ height: "100vh" }}>
     

      <div className={`row g-0 ${sidebarstyle.appcontainer}`}>
        {/* Sidebar */}
        <LeftSideBarChat channelsData={unAllocatedChannelData} openChannels={openChannels} toggleChannel={toggleChannel} selectedUserId={selectedUserId} setSelectedUserId={setSelectedUserId} handleUserClick={handleUserClickLeft}/>
        <CenterSideBarChat channelsData={channelsData} openChannels={openUnallocatedChannels} toggleChannel={toggleUnallocatedChannel} selectedUserId={selectedUserId} setSelectedUserId={setSelectedUserId} handleUserClick={handleUserClick} selectedChannelId={selectedChannelId}/>
        {/* Chat Window */}
        {selectedUserId ? 
        <RightSidebarChat selectedUser={selectedUser} selectedMessages={selectedMessages} input={input} setInput={setInput} handleSend={handleSend} selectedUserId={selectedUserId} livesupportDatas={livesupportDatas} updateLiveSupport={updateLiveSupport} selectedDetails={selectedDetails} handlePostMessage={handlePostMessage}/>:<div className="col-md-6">
            <img
            src="/assets/images/loginimage.svg"
            className={`img-fluid ${login.loginImage}`}
            alt="Login"
          />
        </div>
        }

      </div>
    </div>
  );
}
